/**
 * useGroup Hook
 *
 * React Query hook for fetching a single group with enriched member details.
 */

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { groupService } from '../../../api/group.service';
import type { GroupWithMembers } from '../../../types/group.types';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for fetching a single group
 */
export const useGroup = (
  tenantId: string,
  groupId: string
): UseQueryResult<GroupWithMembers, Error> => {
  return useQuery<GroupWithMembers, Error>({
    queryKey: ['group', tenantId, groupId],
    queryFn: async () => {
      console.log('[useGroup] Fetching group:', groupId);
      return await groupService.getGroup(tenantId, groupId);
    },
    enabled: !!tenantId && !!groupId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    onError: (error) => {
      console.error('[useGroup] Failed to fetch group:', getErrorMessage(error));
    },
  });
};
